import styled, { css } from "styled-components";
import tw from "twin.macro";

import { List } from "../List";
import { ScrollShadow } from "../ScrollShadow";
import { StyledOption } from "../Select/Option/Styles";

export const StyledAutocompleteScrollShadow = styled(ScrollShadow)<{
  $isHidden: boolean;
}>`
  margin-top: 4px;

  ${(props) =>
    props.$isHidden &&
    css`
      ${tw`tw-hidden`};
    `}
`;

StyledAutocompleteScrollShadow.displayName = "StyledAutocompleteScrollShadow";

export const StyledAutocompleteBody = styled(List)`
  max-height: 340px;
  overflow: auto;
  margin-bottom: 6px;
`;

StyledAutocompleteBody.displayName = "StyledAutocompleteBody";

export const StyledAutocompleteNewItem = styled(StyledOption)<{ hover }>`
  ${tw`tw-cursor-pointer tw-select-none`};
  justify-content: start;

  &:before {
    content: "+ ";
    margin-right: 4px;
  }

  ${(props) =>
    props.hover &&
    css`
      background-color: var(--color-theme-200);
      content: "+ ";
    `}
`;

StyledAutocompleteNewItem.displayName = "StyledAutocompleteNewItem";
